import {AfterViewInit, ApplicationRef, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {ContratoService} from "../superadmin/services/contrato.service";
import {CadCartaocreditoComponent} from "../fidelidade/cad-cartaocredito/cad-cartaocredito.component";
import {ModalKendo} from "../lib/ModalKendo";


@Component({
  selector: 'app-ativacao-assinatura',
  templateUrl: './ativacao-assinatura.component.html',
  styleUrls: ['./ativacao-assinatura.component.scss']
})
export class AtivacaoAssinaturaComponent extends ModalKendo implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('cccompoment') cccompoment: CadCartaocreditoComponent;
  contrato: any = { assinatura: {}};
  empresa: any = {  };
  ativando: boolean;
  erro: string;
  pago: boolean;
  reload = true;
  formaPagamentoSelecionada: string;
  codigoAcesso: string;
  codigoFatura: string;
  aceitouDocumentos = false;
  aceitandoDocumentos = false;
  urlAutenticacao3DS: string;
  urlAutenticacao3DSSegura: SafeResourceUrl;
  private urlAutenticacao3DSConcluida: string;
  private pollingAutenticacao3DS: any;
  private sincronizandoAutenticacao3DS = false;
  private readonly messageHandler = (event: MessageEvent) => this.recebaRetorno3DS(event);
  constructor(private contratoService: ContratoService,
              private elRef: ElementRef,
              private app: ApplicationRef,
              private sanitizer: DomSanitizer) {
    super()
  }

  ngOnInit() {
    window.addEventListener('message', this.messageHandler, false);
    this.atualizeEstadoExibicao();
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.messageHandler, false);
    this.parePollingAutenticacao3DS();
  }

  private atualizeEstadoExibicao() {
    this.pago = this.contrato.proximaFatura && this.contrato.proximaFatura.paga;

    if(this.formasPagamentoDisponiveis.indexOf(this.formaPagamentoSelecionada) < 0)
      this.formaPagamentoSelecionada = this.formasPagamentoDisponiveis[0];

    this.atualizeAutenticacao3DS();
    if(this.autenticacao3DSPendente) this.iniciePollingAutenticacao3DS();
    else this.parePollingAutenticacao3DS();
  }

  get pagamentoCartaoPendente(): boolean {
    const fatura = this.contrato?.proximaFatura;
    const status = String(fatura?.statusCartao || '').toUpperCase();
    return !this.pago && !fatura?.cancelada &&
      ['CREATED', 'PROCESSING', 'PENDING', 'ACTIVE', 'REGISTERED', 'PENDING_AUTHENTICATION',
        'WAITING_AUTHENTICATION', 'AUTHORIZED', 'APPROVED', 'CONCLUDED'].indexOf(status) >= 0;
  }

  get autenticacao3DSPendente(): boolean {
    return this.pagamentoCartaoPendente && Boolean(this.contrato?.proximaFatura?.urlAutenticar);
  }

  get formasPagamentoDisponiveis(): string[] {
    const formas: string[] = [];
    const fatura = this.contrato?.proximaFatura;

    if(!this.faturaPodeSerPaga) return formas;

    if(fatura?.pix)
      formas.push('pix');

    if(this.contrato?.pagaNoCartao)
      formas.push('cartao');

    if(fatura?.boleto)
      formas.push('boleto');

    return formas;
  }

  get faturaPodeSerPaga(): boolean {
    const fatura = this.contrato?.proximaFatura;
    return Boolean(fatura) && !this.pago && fatura.podePagar !== false &&
      !fatura.cancelada && !fatura.reembolsada;
  }

  get formaPagamentoAtiva(): string {
    if(this.formasPagamentoDisponiveis.indexOf(this.formaPagamentoSelecionada) >= 0)
      return this.formaPagamentoSelecionada;

    return this.formasPagamentoDisponiveis[0];
  }

  selecioneFormaPagamento(forma: string) {
    if(this.formasPagamentoDisponiveis.indexOf(forma) >= 0)
      this.formaPagamentoSelecionada = forma;
  }

  ehCobrancaGrupo() {
    return this.contrato?.tipoCobranca === 'grupo' || !!this.contrato?.grupoFaturamento?.id;
  }

  ngAfterViewInit() {
    const modalContentHeight = this.elRef.nativeElement.offsetHeight;
    const windowHeight = window.innerHeight;

    if (modalContentHeight > windowHeight) {
      //this.elRef.nativeElement.style.overflowY = 'scroll';
    }
  }

  ativeViaCartao(cartao: any) {
    this.fecheMensagemErro();

    if(this.ativando) return;

    this.urlAutenticacao3DSConcluida = null;
    this.ativando = true;
    this.contratoService.ativeContratoViaCartao(this.contrato, cartao, this.codigoFatura).then( resp => {
      this.ativando = false;
      if(resp && this.contrato.proximaFatura)
        Object.assign(this.contrato.proximaFatura, resp);

      this.processeEstadoFatura(true);
    }).catch( erro => {
      this.erro = erro;
      this.ativando = false;
      this.cccompoment?.canceleProcessando();
    })
  }

  private processeEstadoFatura(exibaErro: boolean = false) {
    this.atualizeEstadoExibicao();

    if(this.pago) {
      this.cccompoment?.canceleProcessando();
      if(this.reload) {
        setTimeout(() => window.location.reload(), 1000);
      }
    } else if(this.pagamentoCartaoPendente) {
      this.fecheMensagemErro();
      this.cccompoment?.canceleProcessando();
    } else if(exibaErro) {
      this.erro = this.contrato?.proximaFatura?.motivoCartao ||
        'Pagamento não aprovado. Tente novamente ou utilize o Pix.';
      this.cccompoment?.canceleProcessando();
    }

    this.app.tick();
  }

  private atualizeAutenticacao3DS() {
    const url = this.autenticacao3DSPendente ? this.contrato?.proximaFatura?.urlAutenticar : null;
    if(!url || url === this.urlAutenticacao3DSConcluida) {
      this.urlAutenticacao3DS = null;
      this.urlAutenticacao3DSSegura = null;
      return;
    }

    try {
      if(new URL(url).protocol !== 'https:') throw Error('URL 3DS inválida');
      this.urlAutenticacao3DS = url;
      this.urlAutenticacao3DSSegura = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    } catch(e) {
      this.urlAutenticacao3DS = null;
      this.urlAutenticacao3DSSegura = null;
    }
  }

  private recebaRetorno3DS(event: MessageEvent) {
    if(event.origin !== window.location.origin || event.data !== 'cellcoin-3ds-return') return;

    this.urlAutenticacao3DSConcluida = this.urlAutenticacao3DS;
    this.urlAutenticacao3DS = null;
    this.urlAutenticacao3DSSegura = null;
    this.sincronizeAutenticacao3DS();
  }

  private iniciePollingAutenticacao3DS() {
    if(!this.pollingAutenticacao3DS)
      this.pollingAutenticacao3DS = setInterval(() => this.sincronizeAutenticacao3DS(), 30000);
  }

  private sincronizeAutenticacao3DS() {
    if(!this.autenticacao3DSPendente) {
      this.parePollingAutenticacao3DS();
      return;
    }

    if(this.sincronizandoAutenticacao3DS) return;
    this.sincronizandoAutenticacao3DS = true;
    const sincronizacao = this.codigoFatura ?
      this.contratoService.sincronizeFaturaPagamentoPublico(this.codigoFatura) :
      this.contratoService.sincronizeFatura(this.contrato.proximaFatura);

    sincronizacao.then((fatura: any) => {
      if(fatura) Object.assign(this.contrato.proximaFatura, fatura);
      this.processeEstadoFatura(true);
    }).catch(() => {}).then(() => this.sincronizandoAutenticacao3DS = false);
  }

  private parePollingAutenticacao3DS() {
    if(this.pollingAutenticacao3DS) clearInterval(this.pollingAutenticacao3DS);
    this.pollingAutenticacao3DS = null;
  }

  fecheMensagemErro() {
    delete this.erro;
  }

  get aceiteDocumentosPendente() {
    return !this.pago && this.contrato?.aceitesDocumentosPendentes !== false;
  }

  continueParaPagamento() {
    if(!this.aceitouDocumentos || this.aceitandoDocumentos) return;

    const codigo = this.codigoAcesso || String(this.contrato.id);
    if(!codigo || codigo === 'undefined') {
      this.erro = 'Não foi possível identificar o contrato. Atualize a página e tente novamente.';
      return;
    }

    this.fecheMensagemErro();
    this.aceitandoDocumentos = true;

    return this.contratoService.registreAceitesDocumentos(codigo)
      .then(() => this.codigoFatura ?
        this.contratoService.obtenhaContratoPagamentoPorFatura(this.codigoFatura) :
        this.contratoService.obtenhaContratoPagamento(codigo))
      .then((contrato: any) => {
        this.contrato = contrato;
        this.atualizeEstadoExibicao();
        this.liberePagamento();
      })
      .catch(erro => {
        console.error('Falha ao registrar aceite dos documentos', erro);
        this.liberePagamento();
      });
  }

  private liberePagamento() {
    this.contrato = this.contrato || {};
    this.contrato.aceitesDocumentosPendentes = false;
    this.aceitandoDocumentos = false;
    this.aceitouDocumentos = false;
    this.app.tick();
  }

}
